export interface QuotePriceDataDto {
  last?: number;
  change?: number;
  changepercent?: number;
  tick?: number;
  open?: number;
  high?: number;
  low?: number;
  prevclose?: number;
  bid?: number;
  ask?: number;
  bidsize?: number;
  asksize?: number;
  tradevolume?: number;
  sharevolume?: number;
  lasttradedatetime?: string;
}

export interface QuoteDto {
  pricedata?: QuotePriceDataDto;
  symbolstring: string;
  datatype: string;
  entitlement: string;
  delaymin?: number;
  datetime?: string;
  isopen?: any;
  symbol: string;
  iscurrentlyopen: boolean;
  longname: string;
  shortname: string;
  exLgName?: string;
  exShName?: string;
  exchange?: string;
}

export interface GetQuoteListQueryParamsDto {
  symbols: string;
}

export interface GetQuoteListDto {
  queryParams: GetQuoteListQueryParamsDto;
}

export interface GetQuoteListResponseDto {
  copyright?: string;
  symbolcount?: number;
  quotedata: QuoteDto[];
}

export interface Week52Data {
  date: string;
  content: number;
}

export interface QuoteDetailPriceDataDto extends QuotePriceDataDto {
  week52high: Week52Data;
  week52low: Week52Data;
  bidclose: number;
  askclose: number;
  bidsizeclose: number;
  asksizeclose: number;
  last?: number;
  change?: number;
  changepercent?: number;
}

export interface QuoteKeyDto {
  symbol: string;
  exchange: string;
  exLgName: string;
  exShName: string;
  marketplace: string;
}

export interface QuoteDetailsDto {
  key: QuoteKeyDto;
  status: any;
  pricedata?: QuoteDetailPriceDataDto;
  symbolstring: string;
  datatype: string;
  entitlement: string;
  datetime: string;
  delaymin: number;
}

export interface GetQuoteParamsDto {
  symbol: string;
}

export interface GetQuoteDto {
  params: GetQuoteParamsDto;
}

export interface IntervalData {
  high: number;
  adjustedlow: number;
  low: number;
  adjustedopen: number;
  adjustedclose: number;
  adjustedhigh: number;
  type: string;
  close: number;
  open: number;
  startdatetime: string;
  sharevolume: number;
  vwap?: number;
  avolume?: number;
  adjustedvwap?: number;
}

export interface EodData {
  date: string;
  changepercent: number;
  high: number;
  low: number;
  vwap?: number;
  change: number;
  close: number;
  open: number;
  sharevolume: number;
  avolume?: number;
}

export interface EquityInfoData {
  longname: string;
  shortname: string;
}

export interface IntraDayData {
  equityinfo: EquityInfoData;
  unadjusted: boolean;
  adjusted: boolean;
  start: string;
  entitlement: string;
  end: string;
  interval: IntervalData[];
  key: QuoteKeyDto;
  symbolstring: string;
}

export interface HistoryData {
  unadjusted: boolean;
  adjusted: boolean;
  start: string;
  end: string;
  eoddata: EodData[];
  symbolstring: string;
}

export interface GetQuoteChartParamsDto {
  symbol: string;
}

export enum GetQuoteChartQueryParamIntervalDto {
  OneDay = '1d',
  OneWeek = '1w',
  OneMonth = '1m',
  SixMonths = '6m',
  OneYear = '1y',
  All = 'all',
}

export interface GetQuoteChartQueryParamsDto {
  interval?: GetQuoteChartQueryParamIntervalDto;
}

export interface GetQuoteChartDto {
  params: GetQuoteChartParamsDto;
  queryParams?: GetQuoteChartQueryParamsDto;
}

export interface GetQuoteChartResponseDto {
  copyright: string;
  symbolcount: number;
  history: HistoryData[];
  intraday: IntraDayData[];
}
